import React, { useMemo, useEffect, useState } from 'react'
import { useTbViewStore, useProjectStore } from '@vt/hooks'
import { pick, get, find, pull, cloneDeep, difference, sum } from 'lodash-es'
// import { Button, Toast } from '@ow/comps'
import clsx from 'clsx'

const Status = function () {
  const [count, setCount] = useState({})
  const customCompsMap = useProjectStore((state) => state.customCompsMap)
  const { CustomFilterStatus } = customCompsMap || {}

  const {
    fields,
    statusConfig,
    setCurrentStatus,
    currentStatus,
    setFilters,
    ditto,
    filters,
    // selectedIds,
    setSelectedIds,
    setIsShowBatchOperate,
    layouts,
    refreshStatus,
    defaultFilters,
    setRefreshStatus,
  } = useTbViewStore((state) =>
    pick(state, [
      'fields',
      'statusConfig',
      'setCurrentStatus',
      'currentStatus',
      'setFilters',
      'ditto',
      'filters',
      // 'selectedIds',
      'setSelectedIds',
      'setIsShowBatchOperate',
      'layouts',
      'refreshStatus',
      'defaultFilters',
      'showRecycle',
      'setRefreshStatus',
    ])
  )
  /** inspect布局右侧内容(暂时先这么写,因为left暂时还没用，后期一起修改) */
  // const inspectRightBtns =
  //   layouts.inspect &&
  //   layouts.inspect.elements &&
  //   layouts.inspect.elements[0] &&
  //   layouts.inspect.elements[0].rightElements

  const rightElements = get(layouts, 'inspect.elements[0].rightElements', [])
  // 状态分组
  const groups = get(statusConfig, 'groups', [])

  const statusSlugs = get(
    find(rightElements, { type: 'status' }),
    'slugs',
    null
  )

  const dot = get(find(rightElements, { type: 'status' }), 'dot', false)

  const allStatus = useMemo(() => {
    return get(
      find(fields, (f) => f.slug === 'specialUcaseExtStatus'),
      'selects',
      []
    )
  }, [fields])

  console.log(statusSlugs || allStatus, 'statusSlugs || allStatus')

  const searchList = (status) => {
    const queries = {
      logicType: 'and',
      queries: [
        {
          slug: 'specialUcaseExtStatus',
          value: status,
          queryType: ['contain'],
        },
      ],
    }
    setFilters(queries)
  }

  const fetchCount = (filter) => {
    ditto
      .fetchCountGroupBy('specialUcaseExtStatus', {
        filters: filter,
      })
      .then((res) => {
        setCount(res.specialUcaseExtStatus)
      })
  }

  useEffect(() => {
    fetchCount(filters)
  }, [])

  useEffect(() => {
    // 状态改变 or 选中数据改变 之后需要隐藏掉批量操作
    setIsShowBatchOperate(false)
    // 状态改变之后需要将选中数据清空
    setSelectedIds([])
  }, [currentStatus])

  useEffect(() => {
    if (refreshStatus) {
      fetchCount(defaultFilters)
      setRefreshStatus(false)
    }
  }, [refreshStatus])

  return (
    <div className="flex item-center justify-between">
      <div
        className="flex items-center bg-white text-xs"
        style={{ width: '100%' }}
      >
        <div
          className="text-center border-r py-4 font-bold"
          style={{ width: '80px' }}
        >
          状态 :
        </div>

        {groups && groups.length ? (
          <>
            {groups.map((item) => {
              const { status, title } = item
              const isFilters = difference(status, currentStatus).length === 0

              const allCount = sum(status.map((s) => count[s] || 0))
              return (
                <div
                  className={clsx(
                    'flex flex-col text-center py-2 border-r cursor-pointer relative',
                    isFilters && 'bg-primary-600 text-white'
                  )}
                  style={{ padding: '10px 15px' }}
                  onClick={() => {
                    let currentStatus_new = cloneDeep(currentStatus)
                    if (difference(status, currentStatus).length === 0) {
                      currentStatus_new = difference(currentStatus_new, status)
                    } else {
                      console.log(status, currentStatus_new)
                      currentStatus_new = [...currentStatus_new, ...status]
                    }
                    setCurrentStatus(currentStatus_new)
                    searchList(currentStatus_new)
                  }}
                >
                  <div key={title}>{title}</div>
                  {/* <div className="text-center">( {allCount} )</div> */}
                  {dot &&
                    allCount !== 0 &&
                    !status.includes('结案') &&
                    !status.includes('整改待审核') && (
                      <div
                        className="absolute"
                        style={{
                          width: '6px',
                          height: '6px',
                          background: '#FA1818',
                          top: '5px',
                          right: '5px',
                          borderRadius: '8px',
                        }}
                      />
                    )}
                  {dot &&
                  allCount !== 0 &&
                  !status.includes('结案') &&
                  !status.includes('整改待审核') ? (
                    <div
                      className="text-center"
                      style={
                        (currentStatus || []).indexOf(status.slug) !== -1
                          ? { color: '#fff' }
                          : { color: '#FA1818' }
                      }
                    >
                      ( {allCount || 0} )
                    </div>
                  ) : (
                    <div className="text-center">( {allCount || 0} )</div>
                  )}
                </div>
              )
            })}
          </>
        ) : (
          <>
            {(statusSlugs || allStatus).map((status) => {
              return (
                <div
                  className={clsx(
                    'flex flex-col text-center py-2 border-r cursor-pointer relative',
                    (currentStatus || []).indexOf(status.slug) !== -1 &&
                      'bg-primary-600 text-white'
                  )}
                  style={{ padding: '10px 15px' }}
                  onClick={() => {
                    const currentStatus_new = cloneDeep(currentStatus)
                    if ((currentStatus_new || []).indexOf(status.slug) !== -1) {
                      pull(currentStatus_new, status.slug)
                    } else {
                      currentStatus_new.push(status.slug)
                    }
                    setCurrentStatus(currentStatus_new)
                    searchList(currentStatus_new)
                  }}
                >
                  <div key={status.slug}>{status.title}</div>
                  {dot &&
                    count[status.slug] &&
                    count[status.slug] !== 0 &&
                    status.slug !== '结案' &&
                    status.slug !== '整改待审核' && (
                      <div
                        className="absolute"
                        style={{
                          width: '6px',
                          height: '6px',
                          background: '#FA1818',
                          top: '5px',
                          right: '5px',
                          borderRadius: '8px',
                        }}
                      />
                    )}
                  {dot &&
                  count[status.slug] &&
                  count[status.slug] !== 0 &&
                  status.slug !== '结案' &&
                  status.slug !== '整改待审核' ? (
                    <div
                      className="text-center"
                      style={
                        (currentStatus || []).indexOf(status.slug) !== -1
                          ? { color: '#fff' }
                          : { color: '#FA1818' }
                      }
                    >
                      ( {count[status.slug] || 0} )
                    </div>
                  ) : (
                    <div className="text-center">
                      ( {count[status.slug] || 0} )
                    </div>
                  )}
                </div>
              )
            })}
          </>
        )}

        {CustomFilterStatus && <CustomFilterStatus />}
        {/* <div className="mr-1 ml-auto">
          {(inspectRightBtns || []).map((btn) => {
            return (
              btn.actionType === 'review' && (
                <Button
                  type="primary"
                  onClick={() => {
                    if (!currentStatus.length) {
                      Toast.error({
                        title: '请选择状态!',
                      })
                    } else if (currentStatus.length > 1) {
                      Toast.error({
                        title: '请选择一种状态!',
                      })
                    } else if (!selectedIds.length) {
                      Toast.error({
                        title: '请勾选数据!',
                      })
                    } else {
                      setIsShowBatchOperate(true)
                    }
                  }}
                >
                  批量操作
                </Button>
              )
            )
          })}
        </div> */}
      </div>
    </div>
  )
}

export default Status
